export default "__VITE_ASSET__BWNZKv1X__"